import React from "react";
import { useAppScope } from "../shared";

export const AppContext = React.createContext();

export const AppScopeProvider = ({ children }) => {
  const value = useAppScope();

  return <AppContext.Provider value={value}>{children}</AppContext.Provider>;
};
